//------------------------------------------------------------------------------
//  This code was generated by typescript template tool 'Typewriter'.
//
//  Changes to this file may cause incorrect behavior and will be lost if
//  the code is regenerated.
//------------------------------------------------------------------------------

import { IModel } from "./Dental-DataModel-Interfaces-IModel";

export class ViberMessage  implements IModel {
    
    id: number;
    viberId: string;
    personId: number;
    createDate: any;
    messageText: string;
    sentDate?: any;
    delayDate?: any;
    messageType: number;
}




  
